export function fibonacci(n: number) {
  return (
    Math.round(((Math.sqrt(5) + 1) / 2) ** Math.abs(n) / Math.sqrt(5)) *
    (n < 0 && n % 2 ? -1 : 1)
  );
}
